const normalizeAssetCode = (value) => `${value || ""}`.trim().toUpperCase();

export const getAssetDisplayIcon = (asset) =>
  asset?.assetIcon ||
  asset?.image ||
  asset?.cmc?.logo ||
  asset?.info?.assetIcon ||
  asset?.info?.image ||
  asset?.info?.cmc?.logo ||
  "";

export const getAssetCode = (asset, fallback = "") =>
  normalizeAssetCode(
    asset?.asset || asset?.symbol || asset?.info?.asset || fallback
  );

const toAssetList = (assets) => {
  if (Array.isArray(assets)) {
    return assets;
  }

  if (assets && typeof assets === "object") {
    return Object.entries(assets).map(([key, asset]) => ({
      ...(asset && typeof asset === "object" ? asset : {}),
      fallbackAssetCode: key,
    }));
  }

  return [];
};

export const findAssetByCode = (assets, code) => {
  const normalizedCode = normalizeAssetCode(code);

  return (
    toAssetList(assets).find(
      (asset) => getAssetCode(asset, asset.fallbackAssetCode) === normalizedCode
    ) || null
  );
};

export const buildAssetImageMap = (assets) => {
  const assetImageMap = new Map();

  toAssetList(assets).forEach((asset) => {
    const assetCode = getAssetCode(asset, asset.fallbackAssetCode);
    const icon = getAssetDisplayIcon(asset);

    if (assetCode && icon) {
      assetImageMap.set(assetCode, icon);
    }
  });

  const zarIcon = assetImageMap.get("ZAR");
  if (zarIcon && !assetImageMap.has("ZAR8")) {
    assetImageMap.set("ZAR8", zarIcon);
  }

  return assetImageMap;
};

export const applyZar8MarketIconFallback = (marketAssets, assetsMetadata) => {
  if (!marketAssets || typeof marketAssets !== "object") {
    return marketAssets;
  }

  const zarIcon = buildAssetImageMap(assetsMetadata).get("ZAR");
  if (!zarIcon) {
    return marketAssets;
  }

  let didUpdate = false;
  const updatedMarketAssets = Object.entries(marketAssets).reduce(
    (assets, [key, asset]) => {
      const assetValue = asset && typeof asset === "object" ? asset : {};
      const assetCode = getAssetCode(assetValue, key);
      const existingIcon = getAssetDisplayIcon(assetValue);

      if (assetCode !== "ZAR8" || existingIcon) {
        return { ...assets, [key]: asset };
      }

      didUpdate = true;
      return {
        ...assets,
        [key]: {
          ...assetValue,
          assetIcon: assetValue.assetIcon || zarIcon,
          image: assetValue.image || zarIcon,
          info: {
            ...(assetValue.info || {}),
            assetIcon: assetValue.info?.assetIcon || zarIcon,
            image: assetValue.info?.image || zarIcon,
          },
        },
      };
    },
    {}
  );

  return didUpdate ? updatedMarketAssets : marketAssets;
};
